import { Routes, Route, Navigate } from 'react-router-dom';

import DeliverymanForm from '@/Pages/motoboys/motoboy-form';
import { MotoboyDetails } from '@/Pages/motoboys/motoboy-details';
import Motoboys from '@/Pages/motoboys/motoboys';
import PageDedicateMotoboy from '@/Pages/motoboys/dedicate-motoboy';

function MotoboysRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Motoboys />} />

      <Route path="/novo" element={<DeliverymanForm />} />

      <Route path="/:motoboyId/editar" element={<DeliverymanForm />} />

      <Route path="/:motoboyId" element={<MotoboyDetails />} />

      <Route path="/:motoboyId/dedicar" element={<PageDedicateMotoboy />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default MotoboysRoutes;
